import instance from './DefaultApi';

export default class RedemptionReportService {
    ControllerName = 'RedemptionReport';

    // get all list data Redemption
    GetRedemptionReport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetRedemptionReport`, tableRequest).then(res => res)
    }

    /// Get Excel Export Redemption
    GetRedemptionExport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetRedemptionExport`,tableRequest).then(res => res)
    }


}